<form
  class="competitor-articles-form"
  [formGroup]="competitorArticleForm()"
>
  @for (field of competitorArticlesFormFields; track $index) {
    @if (competitorArticleData().id > 0 || field.visible) {
      @switch (field.type) {
        @case ('number') {
          <mat-form-field
            appearance="outline"
            [class]="getFieldClass(field.fieldName, field.disabled)"
          >
            <mat-label>
              {{ field.label }}
            </mat-label>
            <input
              #inputElement
              matInput
              appDecimalLimit
              [decimals]="field.decimals || 0"
              [type]="field.type"
              inputmode="decimal"
              [formControlName]="field.fieldName"
              (blur)="handleValueChange(field.fieldName, inputElement.value)"
            >
          </mat-form-field>
        }
        @case ('text') {
          <mat-form-field
            appearance="outline"
            [class]="getFieldClass(field.fieldName, field.disabled)"
            [style.cursor]="getFieldStyleCursor(field.fieldName)"
            (click)="handleClickLink(field.fieldName)"
          >
            <mat-label>
              {{ field.label }}
            </mat-label>
            <input
              matInput
              type="text"
              [formControlName]="field.fieldName"
              (blur)="handleValueChange(field.fieldName)"
            >
          </mat-form-field>
        }
        @case ('select') {
          <app-custom-mat-select
            [label]="field.label"
            [options]="productGroupSelectData()"
            [selectedValueId]="selectedProductGroupId()"
            [fullWidth]="true"
            [isEditModeActive]="isActiveSelectField()"
            [needEmptyValue]="false"
            (selectedChange)="handleSelectedChange($event)"
          />
        }
      }
    }
  }
  @if (!competitorArticleData().id) {
    <div class="buttons-container">
      @if (noFirstData()) {
        <button
          mat-button
          color="warn"
          (click)="handleDeleteData()"
        >
          Удалить
        </button>
      }
      <button
        mat-button
        color="primary"
        [disabled]="competitorArticleForm().invalid"
        (click)="handleCreateData()"
      >
        Сохранить
      </button>
    </div>
  }
</form>
